import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useAddUserPushTokenMutation as UseAddUserPushTokenMutation,
  type useAddUserPushTokenMutation$data
} from '@/__generated__/useAddUserPushTokenMutation.graphql'

type CommitAsyncFn = (token: string) => Promise<useAddUserPushTokenMutation$data>

export const useAddUserPushTokenMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseAddUserPushTokenMutation>(graphql`
    mutation useAddUserPushTokenMutation($input: AddUserPushTokenInput!) {
      addUserPushToken(input: $input) {
        query {
          currentUserUnreadCount
        }
        user {
          isPushNotificationsEnabled
          updatedAt
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (token: string) =>
      new Promise<useAddUserPushTokenMutation$data>((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          // transport-level failures (offline, 5xx, WS drop) invoke onError, not onCompleted — without
          // this the promise would never settle and isEnablingNotifications would stay stuck on.
          onError: (error) => reject(error),
          variables: {
            input: {
              token
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
